<template>
  <section v-if="entity.business_plan_id !== null">
    <collapsable
      :collapsed="collapsed"
      :title="$t('entities.inputs.business_plan')"
    >
      <section class="entity-business-plan px-3">
        <div v-if="entityBusinessPlan !== null">
            <h4>{{entityBusinessPlan.name}}</h4>
            <div v-html="entityBusinessPlan.html_description"> </div>
          </div>
          <div v-else-if="businessPlans.length > 0">
            <h3>{{$t('entities.business_plan')}}</h3>
            {{$t('entities.no_business_plan')}}
          </div>
      </section>
    </collapsable>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import Collapsable from '@/components/common/Collapsable'
export default {
  props: {
    entity: {
      type: Object,
      required: true
    },
    collapsed: {
      type: Boolean,
      required: false
    }
  },
  components: {
    Collapsable
  },
  created: function () {
    this.$store.dispatch('LOAD_BUSINESS_PLANS')
  },
  computed: {
    ...mapGetters([
      'businessPlans'
    ]),
    entityBusinessPlan: function () {
      return this.businessPlans.find(businessPlan => businessPlan.id === this.entity.business_plan_id) || null
    }
  }
}
</script>
